import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6">
      <div className="space-y-1 text-center">
        <p className="text-sm font-medium text-muted-foreground">404</p>
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          The page you tried to reach doesn&apos;t exist or has been moved.
        </p>
      </div>
      <Button asChild variant="default">
        <Link to="/">Back to dashboard</Link>
      </Button>
    </div>
  );
}
